import React from 'react'
import { AnimalDto } from '../../../../interactors/gen/backendClient'
import { Card, CardHeader, CardContent, Button, SxProps } from '@mui/material'
import ReactQuill from 'react-quill'
import { getReadableAnimalFieldLabel } from '../../../../domain/Animal/AnimalDisplay'
import { TrimManager } from '../../../../utils/TrimManager'
import { EditorPrompt } from '../EditorPrompt'
import { useEditAnimalMutation } from '../../../../store/useEditAnimalMutation'
import { useCanEditAnimal } from '../../../../store/useCanEditAnimal'

interface Props {
  animal: AnimalDto
  sx?: SxProps
}

export const AnimalNoteCard: React.FC<Props> = ({ animal, sx }) => {
  const editAnimalMutation = useEditAnimalMutation({})
  const canEditAnimal = useCanEditAnimal()

  const onEditLifeBeforeAssociation = async (newLifeBeforeAssociation: string) => {
    await editAnimalMutation.mutate({ ...animal, lifeBeforeAssociation: newLifeBeforeAssociation })
  }
  return (
    <Card sx={sx}>
      <CardHeader
        title={getReadableAnimalFieldLabel('lifeBeforeAssociation')}
        titleTypographyProps={{ sx: { fontSize: { xs: 15.5, sm: 16 }, fontWeight: 700, lineHeight: 1.2 } }}
        action={
          canEditAnimal && (
            <EditorPrompt
              initialValue={animal.lifeBeforeAssociation || ''}
              onSubmit={onEditLifeBeforeAssociation}
              title={getReadableAnimalFieldLabel('lifeBeforeAssociation')}
            />
          )
        }
      />
      <CardContent sx={{ pt: 0 }}>
        <ReactQuill value={TrimManager.trimIfNeeded(animal.lifeBeforeAssociation)} readOnly={true} theme={'bubble'} />
        {TrimManager.needTrim(animal.lifeBeforeAssociation) && (
          <EditorPrompt
            title={getReadableAnimalFieldLabel('lifeBeforeAssociation')}
            initialValue={animal.lifeBeforeAssociation || ''}
            onSubmit={onEditLifeBeforeAssociation}
            renderButton={(onClick: () => void): JSX.Element => <Button onClick={onClick}>Voir Plus</Button>}
          />
        )}
      </CardContent>
    </Card>
  )
}
